module.exports = __webpack_public_path__ + "img/Polaris (Skye Bank).5b04c34a.png";